/**
 * Crew model
 */
export class Crew {
  rid?: number;
  crewId?: string;
  specialization?: string[];
  relatedContractPartner?: number;
  contractPartnerName?: string;
  active?: boolean;
  employeesPercentSplit?: string[];

  crewTitle?: string;

  getCrewTitle(): string {
    let title = this.crewId ? this.crewId.trim() : '';

    if (this.specialization && this.specialization.length > 0) {
      const trimmedSpecialization = this.specialization.map((spec) =>
        spec.trim()
      );
      title += ' - ' + trimmedSpecialization.join(', ');
    }

    if (this.employeesPercentSplit && this.employeesPercentSplit.length > 0) {
      const trimmedEmployeesPercentSplit = this.employeesPercentSplit.map(
        (emp) => emp.trim()
      );
      title += ' - ' + trimmedEmployeesPercentSplit.join(', ');
    }

    return title;
  }

  constructor(data?: any) {
    if (!data) {
      return;
    }

    this.rid = data[3]?.value;
    this.crewId = data[6]?.value;
    this.specialization = data[7]?.value;
    this.active = data[8]?.value;
    this.relatedContractPartner = data[11]?.value;
    this.contractPartnerName = data[12]?.value;
    this.employeesPercentSplit = data[16]?.value;

    this.crewTitle = this.getCrewTitle();
  }
}
